<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <div class="expiry-date-row">
      <label class="expiry-date-label">Set New Expiry Date :</label>
      <input type="date" class="form-control expiry-date-input" [(ngModel)]="startDate" />
    </div>

    <div class="table-scroll">
      <table class="main-table">
        <thead>
          <tr>
            <th class="sticky-col col-remove"></th>
            <th class="sticky-col">SSO</th>
            <th class="sticky-col">Name</th>
            <th class="sticky-col">Email</th>
            <th class="sticky-col">Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          @for (t of userExpiryRecords; track $index; let i = $index) {
<tr>
            <td class="col-remove">
              <i class="fa fa-times remove-icon"
                 title="Remove Row"
                 (click)="removeRow(i)"></i>
            </td>
            <td>{{ t.SSO_ID }}</td>
            <td>{{ t.DISPLAY_NAME }}</td>
            <td>{{ t.EMAIL }}</td>
            <td>{{ t.EXPIRED_ON }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm"
            type="button"
            [disabled]="userExpiryRecords.length < 1 || saving"
            (click)="save()">
      @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
